import React, { useState, useEffect } from 'react';
import './TableList.css';
import CCHEventFormModal from './CCHEventFormModal';


export default function CCHEventsList() {
  const [events, setEvents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  const [searchTerm, setSearchTerm] = useState('');
  const [sortBy, setSortBy] = useState('name-az');

  const [showAddModal, setShowAddModal] = useState(false);
  const [editingEvent, setEditingEvent] = useState(null);

  const fetchEvents = () => {
    setLoading(true);

    const token = localStorage.getItem("cchToken") || localStorage.getItem("adminToken");
    if (!token) {
      setError('CCHToken lipsă. Reautentifică-te.');
      setLoading(false);
      return;
    }

    fetch('https://www.fro.ro/api/cch/list_events.php', {
      method: 'GET',
      headers: {
        'Authorization': `Bearer ${token}`,
        'Content-Type': 'application/json'
      },
      cache: 'no-store'
    })
      .then(async res => {
        if (!res.ok) {
          const text = await res.text();
          throw new Error(`Eroare ${res.status}: ${text}`);
        }
        return res.json();
      })
      .then(data => {
        if (data.success) {
          setEvents(data.events || []);
          setError(null);
        } else {
          setError(data.message || 'Eroare la încărcarea evenimentelor');
        }
        setLoading(false);
      })
      .catch(err => {
        console.error('Eroare fetch evenimente:', err);
        setError(err.message);
        setLoading(false);
      });
  };

  useEffect(() => {
    fetchEvents();
  }, []);

  const filteredEvents = events.filter(ev =>
    ((ev.name || '') + ' ' + (ev.location || '')).toLowerCase().includes(searchTerm.toLowerCase())
  );

  const sortedEvents = [...filteredEvents].sort((a, b) => {
    if (sortBy === 'name-az') return (a.name || '').localeCompare(b.name || '');
    if (sortBy === 'location-az') return (a.location || '').localeCompare(b.location || '');
    if (sortBy === 'date') return new Date(a.start_date) - new Date(b.start_date);
    return 0;
  });

  if (loading) return <p>Se încarcă evenimentele...</p>;
  if (error) return <p style={{ color: 'red' }}>{error}</p>;

  return (
    <div className="table-list-container">
      <div className="table-list-header">
        <div className="sort-bar">
          <label htmlFor="sort-select" className="sort-label">Sort by:</label>
          <select
            id="sort-select"
            className="sort-select"
            value={sortBy}
            onChange={e => setSortBy(e.target.value)}
          >
            <option value="name-az">A-Z by name</option>
            <option value="location-az">A-Z by location</option>
            <option value="date">Dată</option>
          </select>
        </div>

        <div style={{ display: 'flex', alignItems: 'center', gap: '16px', flex: 1 }}>
          <input
            type="text"
            className="search-bar"
            placeholder="Search"
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
          />

          {/* Buton Adaugă */}
          <button
            className="add-circle-btn"
            onClick={() => {
              setEditingEvent(null);
              setShowAddModal(true);
            }}
            aria-label="Adaugă eveniment"
          >
            <span className="plus-icon">+</span>
          </button>
        </div>
      </div>

      <table className="table-list">
        <thead>
          <tr>
            <th>Nume</th>
            <th>Perioadă</th>
            <th>Locație</th>
            <th>Acțiuni</th>
          </tr>
        </thead>
        <tbody>
          {sortedEvents.length === 0 ? (
            <tr>
              <td colSpan={6}>Nu există evenimente.</td>
            </tr>
          ) : (
            sortedEvents.map(event => (
              <tr key={event.id}>
                <td>{event.name}</td>
                <td>{event.start_date} - {event.end_date}</td>
                <td>{event.location}</td>
                <td className="table-list-actions">
                  <button
                    onClick={e => {
                      e.stopPropagation();
                      setEditingEvent(event);
                      setShowAddModal(true);
                    }}
                  >
                    Edit
                  </button>

                  <button
                    onClick={async (e) => {
                      e.stopPropagation();

                      if (!window.confirm("Sigur vrei să ștergi acest eveniment?")) return;

                      const token =
                        localStorage.getItem('cchToken') ||
                        localStorage.getItem('adminToken');

                      if (!token) {
                        alert("Token lipsă. Reautentifică-te.");
                        return;
                      }

                      if (!token) {
                        alert("Token lipsă. Reautentifică-te.");
                        return;
                      }

                      try {
                        const res = await fetch(
                          `https://www.fro.ro/api/cch/delete_event.php?id=${event.id}`,
                          {
                            method: 'DELETE',
                            headers: {
                              'Authorization': `Bearer ${token}`
                            }
                          }
                        );

                        const data = await res.json();

                        if (data.success) {
                          alert("Eveniment șters cu succes.");
                          fetchEvents(); // reîncărcăm lista
                        } else {
                          alert("Eroare: " + data.message);
                        }

                      } catch (err) {
                        alert("Eroare la conexiune: " + err.message);
                      }
                    }}
                  >
                    Delete
                  </button>

                </td>
              </tr>
            ))
          )}
        </tbody>
      </table>

      {showAddModal && (
        <CCHEventFormModal
          onClose={() => {
            setShowAddModal(false);
            setEditingEvent(null);
            fetchEvents();
          }}
          onEventAdded={fetchEvents}
          editData={editingEvent}
        />
      )}
    </div>
  );
}
